import {Toast} from "@shopify/app-bridge/actions";
import {ClientApplication} from '@shopify/app-bridge';

export function showToast(appBridge: ClientApplication<any>, message: string, duration: number) {
    const toastOptions = {
        message,
        duration
    };
    const toastNotice = Toast.create(appBridge, toastOptions);
    toastNotice.dispatch(Toast.Action.SHOW);
}

